import React from 'react';
import Page from '../components/Idss/Page';
import '../assets/css/little_wallet_new.css';


const Idss = () => {

    return (
        <div>
            <Page />
        </div>
    );
};

export default Idss;


/** WEBPACK FOOTER **
 ** ./src/containers/Idss.js
 **/